import { partition } from 'lodash';

function startsWithAny(str, arr) {
  for (let i = 0; i < arr.length; i++) {
    if (str.startsWith(arr[i])) {
      return true;
    }
  }
  return false;
}

export default {
  methods: {
    findError(path, index, subpath) {
      if (index !== undefined && subpath !== undefined) {
        return this.findError(path + '[' + index + '].' + subpath);
      }

      const errors = this.errors || this.validationErrors;

      if (!errors) {
        return null;
      }

      const err = errors.find(e => e.path === path);
      if (!err) {
        return null;
      }

      return err.message;
    },

    filterErrors(prefix, removePrefix) {
      const errors = this.errors || this.validationErrors;

      if (!errors || !errors.length) {
        return null;
      }

      if (!prefix) {
        return errors;
      }

      const prefixes = Array.isArray(prefix) ? prefix : [ prefix ];
      let [negatives, positives] = partition(prefixes, p => p.startsWith('!'));
      negatives = negatives.map(p => p.substring(1));

      const unfiltered = errors.filter(e =>
          (!positives.length || startsWithAny(e.path, positives))
          &&
          (!negatives.length || !startsWithAny(e.path, negatives))
      );

      return removePrefix
          ? unfiltered.map(e => ({ ...e, path: e.path.substring(prefix.length) }))
          : unfiltered;
    },

    countErrors(prefix) {
      const errors = this.filterErrors(prefix);
      if (!errors) {
        return 0;
      }
      return errors.length;
    }
  }
}
